const React = require('react')
const { TrackJS } = require('trackjs')

const { ErrorBoundary } = require('src/components/ErrorBoundary')
const { env } = require('src/config')

function setupTrackJS() {
  if (env.TRACKJS_TOKEN) {
    TrackJS.install({
      token: env.TRACKJS_TOKEN,
      application: 'developers-portal-gatsby',
      network: { error: false },
      window: { promise: false },
    })
  }
}

exports.onClientEntry = () => {
  setupTrackJS()
}

exports.wrapRootElement = ({ element }) => {
  return <ErrorBoundary>{element}</ErrorBoundary>
}
